<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'addReceipt',
    components: {
      baseEdit,
    },
  };
</script>
